import { AppRegistry } from "react-native";

import * as ExpoCar from "$modules/expo-car";
import { i18n } from "$src/core/contexts/translation";
import Car, {
  isCarIntegrationSupported,
  isCarPlaySupported,
} from "$src/core/services/car/car";
import { setCarRuntime } from "$src/core/services/car/runtime/runtime";
import runCarTask from "$src/core/services/car/task/task";
import runAndroidCarTask, {
  ANDROID_CAR_TASK_KEY,
} from "$src/core/services/car/task/task.androidauto";
import Logging from "$src/core/services/logging/logging";
import config from "$src/flavors/flavor.config";

/** Runs at bundle-eval: a car surface can cold-start the app and the React tree may never mount. */

if (isCarIntegrationSupported) {
  if (config.logging) Logging.init?.(config.logging);

  setCarRuntime({
    api: config.api,
    translate: (key) => i18n.t(key),
  });
}

if (isCarPlaySupported) {
  // Must run after setCarRuntime: the already-connected check is synchronous.
  ExpoCar.registerCarService(
    () => runCarTask,
    (error) => Logging.error("Car service task failed", { error }),
  );
}

if (Car.isSupported) {
  AppRegistry.registerHeadlessTask(
    ANDROID_CAR_TASK_KEY,
    () => () => runAndroidCarTask(),
  );
}
